import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import LoadingMask from '../components/LoadingMask';

export default function PlayersPanel({players, onSelect, loading = false, maxHeight = '400px', fullColumns = false}) {
    return (
        <TableContainer sx={{
            height: '100%',
            minHeight: '400px',
            maxHeight: maxHeight,
            position: 'relative'
        }}>
            <Table stickyHeader size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width: '2%'}}>IGN</TableCell>
                        <TableCell>Nickname</TableCell>
                        {fullColumns && <>
                            <TableCell sx={{width: '2%'}}>XP</TableCell>
                            <TableCell>IP Address</TableCell>
                        </>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <LoadingMask visible={loading} fullScreen={false}/>
                    {players.map((player) => (
                        <TableRow
                            hover={onSelect !== undefined && onSelect !== null}
                            key={player.id}
                            onClick={(event) => onSelect && onSelect(player)}
                            sx={{cursor: 'pointer'}}
                        >
                            <TableCell>{player.ign}</TableCell>
                            <TableCell>{player.nickname}</TableCell>
                            {fullColumns && <>
                                <TableCell>{player.xp}</TableCell>
                                <TableCell>{player.ipAddress}</TableCell>
                            </>}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
